var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Divider } from "../Divider";
// styles
import "./card.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-card-content",
    className: undefined,
    style: undefined,
    dividerBetweenRows: false,
    dividerAtTheEnd: false,
};
const CardTable = (_a) => {
    var { data, dividerBetweenRows, dividerAtTheEnd, className, style } = _a, rest = __rest(_a, ["data", "dividerBetweenRows", "dividerAtTheEnd", "className", "style"]);
    const classList = classNames("tecma-card-table", className);
    return (_jsx("div", Object.assign({ className: classList, style: style }, rest, { children: data.map((item, index) => (_jsxs("div", { children: [_jsxs("div", { className: "table-row", children: [_jsx("span", { className: "row-label", children: item.label }), _jsx("span", { className: "row-value", children: item.value })] }), dividerBetweenRows && index !== data.length - 1 && _jsx(Divider, {}), dividerAtTheEnd && index === data.length - 2 && _jsx(Divider, {})] }, item.label))) })));
};
CardTable.defaultProps = defaultProps;
export default React.memo(CardTable);
